module.exports = __webpack_public_path__ + "static/media/edu9.be76f883.jpg";